import React from 'react'
import { SvgIcon } from '@material-ui/core'

function FilterIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.75 4.75V6.78656L9.7474 12.2867C9.87282 12.4248 9.94231 12.6046 9.94231 12.7911V19.1839L13.0577 18.1553V12.7911C13.0577 12.6046 13.1272 12.4248 13.2526 12.2867L18.25 6.78656V4.75H4.75ZM13.1779 18.1156C13.1779 18.1157 13.178 18.1156 13.1779 18.1156V18.1156ZM3.64118 3.63452C3.89057 3.3875 4.2273 3.25 4.57692 3.25H18.4231C18.7727 3.25 19.1094 3.3875 19.3588 3.63452C19.6084 3.88177 19.75 4.21865 19.75 4.57144V6.85722C19.7499 7.18522 19.6275 7.5006 19.4079 7.74272L14.5577 13.0809V18.2861C14.5575 18.5651 14.4687 18.8367 14.3048 19.0616C14.1411 19.2863 13.9111 19.4532 13.6482 19.54C13.6482 19.54 13.6483 19.54 13.6482 19.54L10.1867 20.6829C9.98814 20.7484 9.77679 20.7663 9.57018 20.735C9.36356 20.7038 9.16688 20.6244 8.9964 20.5027C8.82588 20.3811 8.6863 20.2205 8.58972 20.0339C8.49312 19.8472 8.44247 19.6401 8.44231 19.4296L8.44231 13.0809L3.5926 7.7433C3.37306 7.50117 3.25006 7.18536 3.25 6.85736V4.57144C3.25 4.21865 3.39156 3.88177 3.64118 3.63452Z'
      />
    </SvgIcon>
  )
}

export default FilterIcon
